import { AdminDashboard } from '../components/admin/AdminDashboard';

export function AdminPage() {
  return <AdminDashboard />;
}
